import { render, staticRenderFns } from "./onePickMore.vue?vue&type=template&id=af5282fa&scoped=true"
import script from "./onePickMore.vue?vue&type=script&lang=js"
export * from "./onePickMore.vue?vue&type=script&lang=js"
import style0 from "./onePickMore.vue?vue&type=style&index=0&id=af5282fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5282fa",
  null
  
)

export default component.exports